import type { HomepageData } from '@/data/types';
import homepageData from '@/data/homepage.json';

export function useHomepageData() {
  return {
    homepageData: homepageData as HomepageData
  };
}